import { Helmet } from 'react-helmet-async';

import {
  PATH_MISSION_DEFAULT,
  PATH_MISSION_TOOLKITS_DEFAULT,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { useMissionBreadcrumbPaths } from '../../hooks/useMissionBreadcrumbPaths.hook';
import { useMissionSpaceWording } from '../../hooks/useMissionSpaceWording.hook';
import { Loading } from '../../components/Loading';
import { HouseSearching } from '../../components/Illustrations/HouseSearching';
import { useBuildPaths } from '../../hooks/useBuildPaths.hook';
import { useMissionContext } from '../../contexts/MissionContext/hooks/useMissionContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const MissionToolkitsPage = () => {
  const { missionId, folderId, mission } = useMissionContext();
  const missionBreadcrumbPaths = useMissionBreadcrumbPaths();
  const missionWording = useMissionSpaceWording();

  const { paths: missionPaths } = useBuildPaths(
    {
      default: PATH_MISSION_DEFAULT,
      toolkits: PATH_MISSION_TOOLKITS_DEFAULT,
    },
    { folderId, missionId },
  );

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle(
            `Études et Outils ${missionWording.ofName}`,
            mission?.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          ...missionBreadcrumbPaths,
          {
            to: missionPaths.toolkits,
            label: 'études et outils',
            key: 'toolkits',
          },
        ]}
      />
    </>
  );

  const titleContent = (
    <PageTitle title={`Études et Outils ${missionWording.ofName}`} />
  );

  if (mission) {
    return (
      <>
        {beforeTitleContent}
        <PageTitle code={mission.code} title={mission.consolidation.title} />
        <HouseSearching />
      </>
    );
  }

  // TODO : un pre transformer dans le back pour ajouter aux enabledToolkitIds EXISTANTS de la mission les toolkitIds du missionType
  // Ce transformer sera exécuté à la création mais aussi à la modification de la mission

  return (
    <>
      <Loading />
      {beforeTitleContent}
      {titleContent}
    </>
  );
};
